export default __webpack_public_path__ + "static/media/main_landing_img_1.5809bcf3.png";